export const TRANSLATION_CONSTANTS = {
  FALLBACK_LANG: 'sr',
  LANGUAGES: ['en', 'sr'],
  STORAGE_KEY: 'cmsLanguage',
  LANGUAGE_OPTIONS: [
    { label: 'Srpski', value: 'sr' },
    { label: 'English', value: 'en' },
  ],
};
